import "./hr-line.scss";

const HrLine = (props: any) => {
  const { title } = props;

  return (
    <div className="HrLine">
      <hr className="HrLine--Length" />
      {title}
      <hr className="HrLine--Length" />
    </div>
  );
};

export { HrLine };
export default HrLine;
